module.exports = __webpack_public_path__ + "images/about-search.3b3ab63e6fc3c97b607402f55c2d655d.svg";